
import React from 'react';
import NavBar from '@/components/NavBar';
import TerraceSubmissionForm from '@/components/TerraceSubmissionForm';
import Footer from '@/components/Footer';

const SubmitTerracePage = () => {
  return (
    <div className="flex flex-col min-h-screen bg-warm-cream">
      <NavBar />
      
      <main className="flex-1 w-full">
        <div className="container px-3 sm:px-4 md:px-6 py-4 sm:py-6 md:py-8">
          <TerraceSubmissionForm />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default SubmitTerracePage;
